import _ from 'lodash';
import getHelpers from '../helpers';
const api = getHelpers('api');

// checking APP_VERSION and clearing localStorage
if (window.env.APP_VERSION) {
    if (window.localStorage.getItem('APP_VERSION') !== window.env.APP_VERSION) {
        window.localStorage.clear();
    }

    window.localStorage.setItem('APP_VERSION', window.env.APP_VERSION);
}

let comparedSilage = window.localStorage.getItem('comparedSilageHybrids') ?? '{}';
let comparedSilageItems = JSON.parse(comparedSilage);
let comparedSilageHybrids = _.chain(comparedSilageItems).filter().value();

let comparedGrain = window.localStorage.getItem('comparedGrainHybrids') ?? '{}';
let comparedGrainItems = JSON.parse(comparedGrain);
let comparedGrainHybrids = _.chain(comparedGrainItems).filter().value();

const hybridType = window.localStorage.getItem('hybridType') ?? 'silage';
let silageRegion = window.localStorage.getItem('silageRegion') || null;
if (_.includes(['', 'null', 'undefined'], silageRegion)) {
    silageRegion = null;
}

let grainRegion = window.localStorage.getItem('grainRegion') || null;
if (_.includes(['', 'null', 'undefined'], grainRegion)) {
    grainRegion = null;
}

// initial state
const state = {
    ...window.store,
    comparedSilageHybrids,
    comparedGrainHybrids,
    hybridType,
    silageRegion,
    grainRegion,
    notifications: [],
    timestamp: Date.now(),
}

// getters
const getters = {
    comparedSilageHybrids: (state) => state.comparedSilageHybrids,
    comparedGrainHybrids: (state) => state.comparedGrainHybrids,
    hybridPages: (state) => state.hybrid_pages,
    hybridType: (state) => state.hybridType,
    hybridMapping: (state) => state.hybrid_mapping,
    silageRegion: (state) => state.silageRegion,
    grainRegion: (state) => state.grainRegion,
    notifications: (state) => state.notifications,
    timestamp: (state) => state.timestamp,
    pathNodes: (state) => state.pathNodes,
    route: (state) => (name, params) => {
        let path = '/' + _.get(state, ['routes', name]);

        _.forEach(params, (value, key) => {
            path = _.replace(path, new RegExp(`{${key}[?]?}`), value);
        })

        return path;
    }
}

const actions = {
    addNotification({ commit }, payload) {
        commit('addNotification', payload);
    },
}

// mutations
const mutations = {
    setComparedSilageHybrids(state, payload) {
        state.comparedSilageHybrids = payload;

        // save to localStorage
        let compared = '{}';
        try {
            compared = JSON.stringify(payload);
        } catch (e) {
            //ignore
        }
        window.localStorage.setItem('comparedSilageHybrids', compared);
    },

    setComparedGrainHybrids(state, payload) {
        state.comparedGrainHybrids = payload;

        // save to localStorage
        let compared = '{}';
        try {
            compared = JSON.stringify(payload);
        } catch (e) {
            //ignore
        }
        window.localStorage.setItem('comparedGrainHybrids', compared);
    },

    setHybridType(state, payload) {
        state.hybridType = payload;

        // save to localStorage
        window.localStorage.setItem('hybridType', payload || '');
    },

    setSilageRegion(state, payload) {
        state.silageRegion = payload;

        // save to localStorage
        window.localStorage.setItem('silageRegion', payload || '');
    },

    setGrainRegion(state, payload) {
        state.grainRegion = payload;

        // save to localStorage
        window.localStorage.setItem('grainRegion', payload || '');
    },

    addNotification(state, payload) {
        _.set(state, 'notifications', _.concat(state.notifications, [payload]));
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
